<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        <a href="#" @click.prevent="goBack"><i class="fa fa-angle-left"></i></a>
        Trazabilidad: paletizaje (<span v-if="numProcess">{{ numProcess }})</span>
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <b-spinner class="text-center" v-if="!tableDataMovimientos.length"></b-spinner>

            <div v-if="tableDataMovimientos.length">
              <h6 class="mb-2 font-weight-bold">Movimientos:</h6>
              <table class="table table-sm">
                <thead>
                  <tr class="font-weight-bold text-uppercase">
                    <th class="text-center">#</th>
                    <th class="text-center align-middle">Pallet Origen</th>
                    <th class="text-center">Cantidad</th>
                    <th class="text-center align-middle">Pallet Destino</th>
                    <th class="text-center align-middle">Formato</th>
                    <th class="text-center align-middle">Variedad</th>
                    <th class="text-center align-middle">Huerto</th>
                    <th class="text-center align-middle">Fecha embajale</th>
                    <th class="text-center align-middle">Planta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(content, index) in tableDataMovimientos">
                    <td class="text-center align-middle">{{ index + 1 }}</td>
                    <td class="text-center align-middle">
                      <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeDetailContent(content.Pallet_salida_id, content.Pallet_salida)"
                      >
                        {{ content.Pallet_salida }}
                      </a>
                    </td>
                    <td class="text-center align-middle">{{ content.Cantidad }}</td>
                    <td class="text-center align-middle">
                      <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeDetailContent(content.Pallet_entrada_id, content.Pallet_entrada)"
                      >
                        {{ content.Pallet_entrada }}
                      </a>
                    </td>
                    <td class="text-center align-middle">{{ content.container }}</td>
                    <td class="text-center align-middle">{{ content.variety }}</td>
                    <td class="text-center align-middle">{{ content.origin }}</td>
                    <td class="text-center align-middle">{{ content.creation_date | moment }}</td>
                    <td class="text-center align-middle">{{ content.plant.name }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="font-weight-bold">
                    <td class="text-center"></td>
                    <td class="text-center">TOTALES</td>
                    <td class="text-center">{{ totalQuantityIn }}</td>
                    <td class="left"></td>
                    <td class="left"></td>
                    <td class="left"></td>
                    <td class="left"></td>
                    <td class="left"></td>
                    <td class="text-right"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import moment from "moment";

Vue.use(ClientTable);

export default {
  name: "detailedRepaletizaje",
  props: ["process_id", "numProcess"],
  created() {},
  data() {
    return {
      tableDataPalletIn: [],
      tableDataMovimientos: []
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    }
  },
  computed: {
    totalQuantityIn() {
      return this.tableDataMovimientos.reduce((total, item) => total + item.Cantidad, 0);
    }
  },
  methods: {
    getProcessRepa(process_id) {
      this.tableDataPalletIn = [];
      this.tableDataMovimientos = [];

      this.$axios
        .get("/api/v1/process/" + process_id + "/process_detail_repaletizaje/")
        .then((res) => {
          this.tableDataPalletIn = res.data.movement_content;
          this.loading = false;

          const datos = res.data.movement_content;

          for (let key in datos) {
            var rowNew = {
              Pallet_entrada: datos[key].content.pallet_number,
              Pallet_salida: datos[key].content_reference.pallet_number,
              Pallet_entrada_id: datos[key].content.pallet,
              Pallet_salida_id: datos[key].content_reference.pallet,
              Producto: datos[key].content.product_name,
              Tipo_producto: datos[key].content.product_type_name,
              Variedad: datos[key].content.variety_name,
              origin: datos[key].content_reference.origin_name,
              kilos_brutos: datos[key].content.gross_kilograms,
              kilos_netos: datos[key].content.net_kilograms,
              Cantidad: datos[key].content.quantity,
              IDContenido: datos[key].content.id,
              container: datos[key].content_reference.container.name,
              condition: datos[key].content_reference.condition,
              variety: datos[key].content_reference.variety_name,
              creation_date: datos[key].content_reference.creation_date,
              plant: datos[key].content_reference.plant
            };

            this.tableDataMovimientos.push(rowNew);
          }
        })
        .catch((error) => console.log(error.message));
    },
    seeGuideDetail(waybill_id, numGuia) {
      this.$router.push("/trazabilidad/detailed-waybill-reception/" + waybill_id + "/" + numGuia);
    },
    seeDetailContent(id_pallet, numero_pallet) {
      this.$router.push("/trazabilidad/detailed-pallet-trazability/" + id_pallet + "/" + numero_pallet);
    },
    goBack() {
      this.$router.go(-1);
    },
    moment: function () {
      return moment();
    }
  },
  mounted() {
    this.getProcessRepa(this.process_id);
  }
};
</script>
